import { api } from '@api/api2';

const getContactCalls = () => api.v1('get', 'contact-center/calls/recent');

const clearEndedCalls = () => api.v1('post', 'contact-center/calls/recent/clear-ended');

export const callsApi = {
  getContactCalls,
  clearEndedCalls,
};
